import { Component } from "react";
import { findDOMNode } from "react-dom";
import { XYCoord } from "dnd-core";
import {
	ConnectDragSource,
	ConnectDropTarget,
	DropTargetMonitor
} from "react-dnd";

export interface InjectedSortableProps {
	sortIndex: number;
	isDragging?: boolean;
	connectDragSource?: ConnectDragSource;
	connectDropTarget?: ConnectDropTarget;
	moveSortable: (dragIndex: number, hoverIndex: number) => void;
}

export const sortableSource = {
	beginDrag(props: InjectedSortableProps) {
		return {
			sortIndex: props.sortIndex
		};
	}
};

export const sortableTarget = {
	hover(
		props: InjectedSortableProps,
		monitor: DropTargetMonitor,
		component: Component | null
	) {
		if (!component) {
			return;
		}

		const dragIndex = monitor.getItem().sortIndex;
		const hoverIndex = props.sortIndex;

		if (dragIndex === hoverIndex) {
			return;
		}

		const hoverBoundingRect = (findDOMNode(
			component
		) as Element).getBoundingClientRect();

		const hoverMiddleY =
			(hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
		const clientOffset = monitor.getClientOffset();
		const hoverClientY =
			(clientOffset as XYCoord).y - hoverBoundingRect.top;

		if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
			return;
		}

		if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
			return;
		}

		props.moveSortable(dragIndex, hoverIndex);
		monitor.getItem().sortIndex = hoverIndex;
	}
};
